
import { useEffect } from 'react';
import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';
import FloatingButtons from '../../../components/feature/FloatingButtons';

const OturumKartiPage = () => {
  useEffect(() => {
    document.title = 'Oturum Kartı Başvuruları | İzmir Vize Danışmanlığı';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        'content',
        'Avrupa ülkeleri oturum kartı başvuruları. İkamet izni süreçlerinde profesyonel danışmanlık ve evrak hazırlığı hizmeti.'
      );
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <main className="pt-20">
        {/* Hero Section */}
        <section className="relative py-16 md:py-24 overflow-hidden">
          <div className="absolute inset-0 z-0">
            <img
              src="https://public.readdy.ai/ai/img_res/caa3ce8382f2701085936c075382eff2.jpg"
              alt="Oturum Kartı"
              className="w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-navy-900/95 via-navy-900/90 to-navy-900/95"></div>
          </div>

          <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
            <span className="inline-block px-4 py-2 md:px-6 md:py-3 bg-cream-400 text-navy-900 text-xs font-semibold tracking-widest uppercase rounded-full mb-4 md:mb-6">
              İkamet İzni
            </span>
            <h1 className="font-display text-3xl md:text-5xl lg:text-6xl font-bold text-cream-100 mb-4 md:mb-6">
              Oturum Kartı Danışmanlığı
            </h1>
            <p className="text-cream-200 text-base md:text-xl lg:text-2xl leading-relaxed mb-6 md:mb-8">
              Avrupa ülkeleri ikamet izni başvurularında profesyonel destek ve süreç yönetimi
            </p>
            <div className="flex flex-col sm:flex-row gap-3 md:gap-4">
              <a
                href="https://wa.me/905514803007?text=Merhaba%2C%20karsiyakavisaconsulting.com.tr%20web%20siteniz%20%C3%BCzerinden%20yaz%C4%B1yorum."
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center px-6 py-3 md:px-8 md:py-4 bg-green-600 text-white rounded-full font-bold text-sm md:text-lg hover:bg-green-700 transition-all hover:scale-105 shadow-xl cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-fill text-xl md:text-2xl mr-2"></i>
                WhatsApp ile İletişim
              </a>
              <a
                href="tel:+905514803007"
                className="inline-flex items-center justify-center px-6 py-3 md:px-8 md:py-4 bg-cream-400 text-navy-900 rounded-full font-bold text-sm md:text-lg hover:bg-cream-300 transition-all hover:scale-105 shadow-xl cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-fill text-xl md:text-2xl mr-2"></i>
                Hemen Ara
              </a>
            </div>
          </div>
        </section>

        {/* Content Section */}
        <section className="py-12 md:py-20 bg-white">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="prose prose-lg max-w-none">
              <h2 className="font-display text-2xl md:text-4xl font-bold text-navy-900 mb-4 md:mb-6">
                Oturum Kartı (İkamet İzni) Nedir?
              </h2>
              <p className="text-navy-700 text-base md:text-lg leading-relaxed mb-6">
                Oturum kartı veya ikamet izni, yabancı bir ülkede yasal olarak yaşama hakkı veren resmi bir belgedir.
                Avrupa ülkelerinde çalışma, eğitim, aile birleşimi veya diğer uzun süreli kalış amaçları için oturum
                kartı başvurusu yapılması gerekmektedir. Oturum kartı, vize süresinden daha uzun kalış imkanı sağlar ve
                genellikle 1-5 yıl arası geçerlilik süresine sahiptir.
              </p>
              <p className="text-navy-700 text-base md:text-lg leading-relaxed mb-8">
                Her ülkenin oturum kartı başvuru prosedürleri, gereksinimleri ve hakları farklılık gösterir. Başvuru süreci
                genellikle karmaşık ve uzun sürelidir, bu nedenle profesyonel danışmanlık almak önemlidir. Doğru hazırlanan
                bir başvuru, sürecin hızlı ve sorunsuz ilerlemesini sağlar.
              </p>

              <h2 className="font-display text-2xl md:text-4xl font-bold text-navy-900 mb-4 md:mb-6">
                Oturum Kartı Türleri
              </h2>
              <div className="grid md:grid-cols-2 gap-4 md:gap-6 mb-8">
                <div className="bg-gradient-to-br from-navy-900 to-navy-800 rounded-2xl p-6">
                  <div className="w-12 h-12 bg-cream-400 rounded-xl flex items-center justify-center mb-4">
                    <i className="ri-briefcase-line text-2xl text-navy-900"></i>
                  </div>
                  <h3 className="font-display text-xl font-bold text-cream-100 mb-2">
                    Çalışma İzni Bazlı Oturum
                  </h3>
                  <p className="text-cream-200 text-sm">
                    İş sözleşmesi veya çalışma izni olan kişiler için düzenlenir. İşveren sponsorluğu gerektirir ve
                    genellikle 1-2 yıl geçerlidir.
                  </p>
                </div>

                <div className="bg-gradient-to-br from-cream-400 to-cream-300 rounded-2xl p-6">
                  <div className="w-12 h-12 bg-navy-900 rounded-xl flex items-center justify-center mb-4">
                    <i className="ri-book-open-line text-2xl text-cream-100"></i>
                  </div>
                  <h3 className="font-display text-xl font-bold text-navy-900 mb-2">Öğrenci Oturumu</h3>
                  <p className="text-navy-700 text-sm">
                    Üniversite veya yüksekokul öğrencileri için düzenlenir. Eğitim süresi boyunca geçerlidir ve
                    yenilenebilir.
                  </p>
                </div>

                <div className="bg-gradient-to-br from-cream-300 to-cream-200 rounded-2xl p-6">
                  <div className="w-12 h-12 bg-navy-900 rounded-xl flex items-center justify-center mb-4">
                    <i className="ri-group-line text-2xl text-cream-100"></i>
                  </div>
                  <h3 className="font-display text-xl font-bold text-navy-900 mb-2">
                    Aile Birleşimi Oturumu
                  </h3>
                  <p className="text-navy-700 text-sm">
                    Ülkede yasal olarak ikamet eden aile üyelerine katılmak için düzenlenir. Evlilik veya akrabalık
                    belgesi gerektirir.
                  </p>
                </div>

                <div className="bg-gradient-to-br from-navy-800 to-navy-700 rounded-2xl p-6">
                  <div className="w-12 h-12 bg-cream-400 rounded-xl flex items-center justify-center mb-4">
                    <i className="ri-home-line text-2xl text-navy-900"></i>
                  </div>
                  <h3 className="font-display text-xl font-bold text-cream-100 mb-2">
                    Uzun Dönem İkamet
                  </h3>
                  <p className="text-cream-200 text-sm">
                    5 yıl yasal ikamet sonrası başvurulabilir. Kalıcı oturum hakkı sağlar ve yenileme gerektirmez.
                  </p>
                </div>

                <div className="bg-gradient-to-br from-cream-400 to-cream-300 rounded-2xl p-6">
                  <div className="w-12 h-12 bg-navy-900 rounded-xl flex items-center justify-center mb-4">
                    <i className="ri-money-euro-circle-line text-2xl text-cream-100"></i>
                  </div>
                  <h3 className="font-display text-xl font-bold text-navy-900 mb-2">
                    Yatırım Bazlı Oturum
                  </h3>
                  <p className="text-navy-700 text-sm">
                    Gayrimenkul yatırımı veya iş kurma yoluyla elde edilen oturum izni. Ülkeye göre minimum yatırım
                    tutarı değişir.
                  </p>
                </div>

                <div className="bg-gradient-to-br from-navy-900 to-navy-800 rounded-2xl p-6">
                  <div className="w-12 h-12 bg-cream-400 rounded-xl flex items-center justify-center mb-4">
                    <i className="ri-heart-pulse-line text-2xl text-navy-900"></i>
                  </div>
                  <h3 className="font-display text-xl font-bold text-cream-100 mb-2">Emekli Oturumu</h3>
                  <p className="text-cream-200 text-sm">
                    Emekli maaşı alan ve belirli mali kriterleri karşılayan kişiler için düzenlenir. Bazı ülkelerde
                    özel programlar mevcuttur.
                  </p>
                </div>
              </div>

              <h2 className="font-display text-2xl md:text-4xl font-bold text-navy-900 mb-4 md:mb-6">
                Başvuru Süreci
              </h2>
              <div className="space-y-4 mb-8">
                <div className="bg-gradient-to-r from-navy-900 to-navy-800 rounded-xl p-6 text-cream-100">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 bg-cream-400 rounded-full flex items-center justify-center flex-shrink-0">
                      <span className="text-navy-900 font-bold">1</span>
                    </div>
                    <div>
                      <h3 className="font-bold text-lg mb-2">Ön Değerlendirme ve Planlama</h3>
                      <p className="text-cream-200">
                        Profiliniz, amacınız ve hedef ülke detaylı şekilde analiz edilir. Size uygun oturum kartı türü
                        belirlenir.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-gradient-to-r from-cream-400 to-cream-300 rounded-xl p-6">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 bg-navy-900 rounded-full flex items-center justify-center flex-shrink-0">
                      <span className="text-cream-100 font-bold">2</span>
                    </div>
                    <div>
                      <h3 className="font-bold text-navy-900 text-lg mb-2">Evrak Toplama ve Hazırlık</h3>
                      <p className="text-navy-700">
                        Tüm gerekli belgeler toplanır, tercüme edilir, apostil işlemleri yapılır ve resmi standartlara
                        uygun hale getirilir.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-gradient-to-r from-navy-800 to-navy-700 rounded-xl p-6 text-cream-100">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 bg-cream-400 rounded-full flex items-center justify-center flex-shrink-0">
                      <span className="text-navy-900 font-bold">3</span>
                    </div>
                    <div>
                      <h3 className="font-bold text-lg mb-2">Başvuru Yapılması</h3>
                      <p className="text-cream-200">
                        Başvuru formu doldurulur ve tüm evraklar ilgili makama (konsolosluk, göçmenlik ofisi vb.) teslim
                        edilir.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-gradient-to-r from-cream-300 to-cream-200 rounded-xl p-6">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 bg-navy-900 rounded-full flex items-center justify-center flex-shrink-0">
                      <span className="text-cream-100 font-bold">4</span>
                    </div>
                    <div>
                      <h3 className="font-bold text-navy-900 text-lg mb-2">Biyometrik İşlemler</h3>
                      <p className="text-navy-700">
                        Parmak izi, fotoğraf ve diğer biyometrik veriler kaydedilir.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-gradient-to-r from-navy-900 to-navy-800 rounded-xl p-6 text-cream-100">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 bg-cream-400 rounded-full flex items-center justify-center flex-shrink-0">
                      <span className="text-navy-900 font-bold">5</span>
                    </div>
                    <div>
                      <h3 className="font-bold text-lg mb-2">Değerlendirme Süreci</h3>
                      <p className="text-cream-200">
                        İlgili makam başvurunuzu inceler. Bu süre ülkeye ve oturum türüne göre 2-6 ay arasında değişir.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-gradient-to-r from-cream-400 to-cream-300 rounded-xl p-6">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 bg-navy-900 rounded-full flex items-center justify-center flex-shrink-0">
                      <span className="text-cream-100 font-bold">6</span>
                    </div>
                    <div>
                      <h3 className="font-bold text-navy-900 text-lg mb-2">Oturum Kartı Teslimi</h3>
                      <p className="text-navy-700">
                        Başvuru onaylandıktan sonra oturum kartınızı teslim alırsınız ve yasal olarak ülkede ikamet
                        edebilirsiniz.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <h2 className="font-display text-2xl md:text-4xl font-bold text-navy-900 mb-4 md:mb-6">
                Genel Gerekli Evraklar
              </h2>
              <div className="bg-cream-50 rounded-2xl p-6 md:p-8 mb-8 border-2 border-cream-200">
                <p className="text-navy-700 text-base md:text-lg mb-6">
                  Oturum kartı başvuruları için genellikle aşağıdaki belgeler istenir. Ancak her ülke ve oturum türü
                  için gereksinimler farklılık gösterebilir:
                </p>
                <ul className="space-y-3 text-navy-700">
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-navy-900 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg">
                      <strong>Pasaport:</strong> En az 6 ay geçerlilik süresi olan pasaport ve tüm sayfaların fotokopisi
                    </span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-navy-900 text-xl mr-3 mt-1"></i>
                    <span className="text-base md:text-lg">
                      <strong>Başvuru Formu:</strong> Eksiksiz ve doğru doldurulmuş resmi başvuru formu
                    </span>
                  </li>
                  {/* ... other list items remain unchanged ... */}
                </ul>
              </div>

              <h2 className="font-display text-2xl md:text-4xl font-bold text-navy-900 mb-4 md:mb-6">
                Popüler Oturum Kartı Ülkeleri
              </h2>
              <div className="grid md:grid-cols-3 gap-4 mb-8">
                <div className="bg-white border-2 border-cream-200 rounded-xl p-6 hover:shadow-lg transition-shadow">
                  <h3 className="font-bold text-navy-900 text-lg mb-2">🇩🇪 Almanya</h3>
                  <p className="text-navy-600 text-sm">
                    Güçlü ekonomi, iş imkanları ve kaliteli yaşam standartları ile popüler tercih.
                  </p>
                </div>
                <div className="bg-white border-2 border-cream-200 rounded-xl p-6 hover:shadow-lg transition-shadow">
                  <h3 className="font-bold text-navy-900 text-lg mb-2">🇪🇸 İspanya</h3>
                  <p className="text-navy-600 text-sm">
                    Altın vize programı ve uygun iklim koşulları ile tercih edilen ülke.
                  </p>
                </div>
                <div className="bg-white border-2 border-cream-200 rounded-xl p-6 hover:shadow-lg transition-shadow">
                  <h3 className="font-bold text-navy-900 text-lg mb-2">🇵🇹 Portekiz</h3>
                  <p className="text-navy-600 text-sm">
                    Yatırım bazlı oturum programları ve düşük yaşam maliyeti ile cazip seçenek.
                  </p>
                </div>
                {/* ... other country cards ... */}
              </div>

              <h2 className="font-display text-2xl md:text-4xl font-bold text-navy-900 mb-4 md:mb-6">
                Profesyonel Danışmanlık Hizmetimiz
              </h2>
              <div className="bg-gradient-to-br from-navy-900 to-navy-800 rounded-2xl p-6 md:p-8 mb-8">
                <div className="grid md:grid-cols-2 gap-6">
                  <div className="bg-cream-100/10 rounded-xl p-6">
                    <i className="ri-file-list-3-fill text-4xl text-cream-400 mb-4"></i>
                    <h3 className="font-bold text-cream-100 text-lg mb-2">Evrak Yönetimi</h3>
                    <p className="text-cream-200 text-sm">
                      Tüm belgelerin toplanması, tercümesi, apostil işlemleri ve düzenlenmesi
                    </p>
                  </div>
                  <div className="bg-cream-100/10 rounded-xl p-6">
                    <i className="ri-guide-fill text-4xl text-cream-400 mb-4"></i>
                    <h3 className="font-bold text-cream-100 text-lg mb-2">Süreç Rehberliği</h3>
                    <p className="text-cream-200 text-sm">
                      Başvurunun her aşamasında profesyonel destek ve bilgilendirme
                    </p>
                  </div>
                  <div className="bg-cream-100/10 rounded-xl p-6">
                    <i className="ri-calendar-check-fill text-4xl text-cream-400 mb-4"></i>
                    <h3 className="font-bold text-cream-100 text-lg mb-2">Randevu Yönetimi</h3>
                    <p className="text-cream-200 text-sm">
                      Konsolosluk ve resmi kurum randevularının alınması ve takibi
                    </p>
                  </div>
                  <div className="bg-cream-100/10 rounded-xl p-6">
                    <i className="ri-customer-service-2-fill text-4xl text-cream-400 mb-4"></i>
                    <h3 className="font-bold text-cream-100 text-lg mb-2">Sürekli İletişim</h3>
                    <p className="text-cream-200 text-sm">
                      Başvuru sürecinde düzenli bilgilendirme ve destek
                    </p>
                  </div>
                </div>
              </div>

              <h2 className="font-display text-2xl md:text-4xl font-bold text-navy-900 mb-4 md:mb-6">
                Sıkça Sorulan Sorular
              </h2>
              <div className="space-y-4 mb-8">
                <div className="bg-white border-2 border-cream-200 rounded-xl p-6">
                  <h3 className="font-bold text-navy-900 text-lg mb-2">
                    Oturum kartı başvurusu ne kadar sürer?
                  </h3>
                  <p className="text-navy-600">
                    Ülkeye ve oturum türüne göre 2-6 ay arasında değişir. Bazı ülkelerde hızlandırılmış işlem
                    seçenekleri mevcuttur.
                  </p>
                </div>
                {/* ... other FAQ items ... */}
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-12 md:py-20 bg-gradient-to-br from-navy-900 to-navy-800">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="font-display text-3xl md:text-5xl font-bold text-cream-100 mb-4 md:mb-6">
              Oturum Kartı Başvurunuzu Başlatın
            </h2>
            <p className="text-cream-300 text-base md:text-xl mb-6 md:mb-8 leading-relaxed">
              İkamet izni süreçlerinde profesyonel destek için bizimle iletişime geçin
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
              <a
                href="https://wa.me/905514803007?text=Merhaba%2C%20karsiyakavisaconsulting.com.tr%20web%20siteniz%20%C3%BCzerinden%20yaz%C4%B1yorum."
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center px-6 py-3 md:px-10 md:py-5 bg-green-600 text-white rounded-full font-bold text-base md:text-xl hover:bg-green-700 transition-all hover:scale-105 shadow-2xl cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-fill text-2xl md:text-3xl mr-2 md:mr-3"></i>
                WhatsApp ile İletişim
              </a>
              <a
                href="tel:+905514803007"
                className="inline-flex items-center px-6 py-3 md:px-10 md:py-5 bg-cream-400 text-navy-900 rounded-full font-bold text-base md:text-xl hover:bg-cream-300 transition-all hover:scale-105 shadow-2xl cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-fill text-2xl md:text-3xl mr-2 md:mr-3"></i>
                Hemen Ara
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />
      <FloatingButtons />
    </div>
  );
};

export default OturumKartiPage;
